import { useImperativeHandle, forwardRef, useState, useRef, useEffect } from 'react';
import FJConstant from '../../../constants/FJConstant';
import styles from './FJImagePreviewItem.module.less';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';
import PropTypes from 'prop-types';
import FJCanvasUtil from '../../../util/FJCanvasUtil';

const FJImagePreviewItem = forwardRef((props, ref) => {
    const {
        imgUrl,
        originalUrl,

        isLoading = false,
        isTransparentBG = false,
        isComparison = false,

        sourceLoadStatus,
        setSourceLoadStatus,
        setSourceOriginLoadStatus,
    } = props;

    const [stateImgUrl, setStateImgUrl] = useState(imgUrl);
    const [stateOriginImgUrl, setStateOriginImgUrl] = useState(originalUrl);
    const transparentBgCanvasRef = useRef(null);
    const loading = isLoading || sourceLoadStatus === FJConstant.LOADING;

    useEffect(() => {
        if (isTransparentBG && transparentBgCanvasRef.current) {
            const canvas = transparentBgCanvasRef.current;
            const rect = canvas.getBoundingClientRect();
            const ctx = canvas.getContext('2d');
            canvas.width = rect.width;
            canvas.height = rect.height;

            FJCanvasUtil.drawTransparentBackground(ctx, rect.width, rect.height, 10);
        }
    }, [isTransparentBG]);

    const _sourceReload = () => {
        setSourceLoadStatus(FJConstant.LOADING);
        setStateImgUrl(FJUtil.getReloadNewUrl(stateImgUrl));
    };

    const _originSourceReload = () => {
        setSourceOriginLoadStatus(FJConstant.LOADING);
        setStateOriginImgUrl(FJUtil.getReloadNewUrl(stateOriginImgUrl));
    };

    useImperativeHandle(ref, () => ({
        sourceReload: _sourceReload,
        originSourceReload: _originSourceReload,
    }));

    return (
        <>
            {isTransparentBG && <canvas ref={transparentBgCanvasRef} className={styles.transparent_bg}></canvas>}
            <img
                className={classNames(
                    styles.img_item,
                    (sourceLoadStatus !== FJConstant.SUCCESS || loading) && styles.opacity_0,
                )}
                src={stateImgUrl}
                onLoad={() => {
                    setSourceLoadStatus(FJConstant.SUCCESS);
                }}
                onError={() => {
                    setSourceLoadStatus(FJConstant.ERROR);
                }}
                loading='lazy'
                // onDragStart={_onForbidDrag}
            />

            {stateOriginImgUrl && (
                <div
                    className={classNames(
                        styles.comparison_box,
                        isComparison ? styles.show : styles.hide,
                        loading && styles.opacity_0,
                    )}
                >
                    <img
                        className={classNames(styles.comparison_img)}
                        src={stateOriginImgUrl}
                        alt=''
                        onLoad={() => {
                            setSourceOriginLoadStatus(FJConstant.SUCCESS);
                        }}
                        onError={() => {
                            setSourceOriginLoadStatus(FJConstant.ERROR);
                        }}
                        loading='lazy'
                    />
                </div>
            )}
        </>
    );
});

FJImagePreviewItem.displayName = 'FJImagePreviewItem';

FJImagePreviewItem.propTypes = {
    imgUrl: PropTypes.string.isRequired,
    originalUrl: PropTypes.string,
    isLoading: PropTypes.bool,
    isTransparentBG: PropTypes.bool,
    isComparison: PropTypes.bool,
    sourceLoadStatus: PropTypes.string,
    setSourceLoadStatus: PropTypes.func,
    setSourceOriginLoadStatus: PropTypes.func,
};

export default FJImagePreviewItem;
